import { useState } from 'react';
import InitFilters from '../../constants/InitFilteringShebasList';

const useCustomHook = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [filters, setFilters] = useState(InitFilters());

  const [isNewDialogOpen, setIsNewDialogOpen] = useState(false);
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);

  const [itemIdToDelete, setItemIdToDelete] = useState(null); // id of item to delete
  const [currentId, setCurrentId] = useState(null);

  const [shebaNumber, setShebaNumber] = useState(null);
  const [shebaName, setShebaName] = useState(null);
  const [page, setPage] = useState(null);
  const [isLoadingDelete, setIsLoadingDelete] = useState(false);

  return {
    isLoading,
    setIsLoading,
    list,
    setList,
    isSubmitting,
    setIsSubmitting,
    setFilterParams,
    size,
    setSize,
    filters,
    setFilters,
    isNewDialogOpen,
    setIsNewDialogOpen,
    confirmDeleteModal,
    setConfirmDeleteModal,
    itemIdToDelete,
    setItemIdToDelete,
    currentId,
    setCurrentId,
    shebaNumber,
    setShebaNumber,
    shebaName,
    setShebaName,
    page,
    setPage,
    isLoadingDelete,
     setIsLoadingDelete,
  };
};

export default useCustomHook;
